import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF0000', // Bright red
    },
    secondary: {
      main: '#000000', // Black
    },
    background: {
      default: '#1C1C1C', // Dark gray/black for background
      paper: '#2C2C2C', // Slightly lighter gray for paper elements
    },
    text: {
      primary: '#FFFFFF', // White text for contrast
      secondary: '#FF0000', // Red text for secondary elements
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif', // UFC often uses bold, sans-serif fonts
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
      color: '#FF0000',
    },
    h2: {
      fontWeight: 700,
      fontSize: '2rem',
      color: '#FFFFFF',
    },
    body1: {
      fontSize: '1rem',
      color: '#FFFFFF',
    },
    button: {
      fontWeight: 700,
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '6px', // Match the rounding in Header.tsx
          padding: '3px 10px', // Match the padding in Header.tsx
          fontSize: '0.8rem', // Match the font size in Header.tsx
          boxShadow: 'none ',
          '&:hover': {
            backgroundColor: '#FF0000',
            color: '#FFFFFF',
          },
        },
      },
    },
  },
});

export default theme;
